import _ from 'underscore'
import Utility from '../../Utility';

class PlantManagementUtility {
    static NOT_DEPLOY_LAYOUT = '';

    static HEAT_EXCHANGER_STATE = {
        UN_WORKED: 0, // 未洗浄.
        PRETEST_COMPLETE: 1, // 前検完了.
        CLEANING: 2, // 洗浄中.
        CLEAN_COMPLETE: 3, // 洗浄完了.
        CARRY_OUT_WAIT: 4, // 搬出待ち.
        CARRY_OUT_COMPLETE: 5 // 搬出済み.
    };

    static PARAM_BOOL = {
        TRUE: '○',
        FALSE: ''
    };

    // 洗浄範囲の種別.
    static CLEANING_RANGE_TYPE = {
        INNER: 'inner',
        OUTER: 'outer',
        SUPER_HIGH: 'superHigh'
    };

    // 工法の一意キー.
    static CONSTRUCTION_METHOD_KEY = {
        INNER_GAN1: 'innerGan1',
        INNER_GAN2: 'innerGan2',
        INNER_FLEXI1: 'innerFlexi1',
        INNER_FLEXI2: 'innerFlexi2',
        INNER_EQUIPMENT1: 'innerEquipment1',
        INNER_EQUIPMENT2: 'innerEquipment2',
        INNER_LANCE1: 'innerLance1',
        INNER_LANCE2: 'innerLance2',
        OUTER_GAN1: 'outerGan1',
        OUTER_GAN2: 'outerGan2',
        OUTER_EQUIPMENT1: 'outerEquipment1',
        OUTER_EQUIPMENT2: 'outerEquipment2',
        SUPER_HIGH_NUM1: 'superHighNum1',
        SUPER_HIGH_NUM2: 'superHighNum2',
    };

    // 洗浄範囲の各パラメータ.
    static CLEANING_RANGE_PARAM = {
        CONSTRUCTION_METHOD: 'constructionMethod',
        SPECIFICATION: 'specification',
        NOZZLE: 'nozzle',
        PRESSURE: 'pressure',
        IS_START: 'isStart',
        START_DATETIME: 'startDatetime',
        IS_STOP: 'isStop',
        STOP_DATETIME: 'stopDatetime',
        STOP_CUMULATIVE_MINUTE: 'stopCumulativeMinute',
        IS_COMPLETE: 'isComplete',
        COMPLETE_DATETIME: 'completeDatetime',
        WORK_CUMULATIVE_MINUTE: 'workCumulativeMinute',
        ADDITIONAL_REASON: 'additionalReason',
    };

    // 工法のラベル.
    static CONSTRUCTION_METHOD_LABEL_MAP = new Map([
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_GAN1, 'ｶﾞﾝ①'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_GAN2, 'ｶﾞﾝ②'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_FLEXI1, 'ﾌﾚｷ①'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_FLEXI2, 'ﾌﾚｷ②'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_EQUIPMENT1, '装置①'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_EQUIPMENT2, '装置②'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_LANCE1, 'ﾗﾝｽ①'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_LANCE2, 'ﾗﾝｽ②'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_GAN1, 'ｶﾞﾝ①'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_GAN2, 'ｶﾞﾝ②'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_EQUIPMENT1, '装置①'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_EQUIPMENT2, '装置②'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.SUPER_HIGH_NUM1, '本数①'],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.SUPER_HIGH_NUM2, '本数②'],
    ]);

    // 内面のｶﾞﾝ①のパラメーター項目.
    static PARAM_MAP_INNER_GAN1 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrisGan1ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrisGan1Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrisGan1Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrisGan1Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrisGan1IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrisGan1StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrisGan1IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrisGan1StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrisGan1StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrisGan1IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrisGan1CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrisGan1WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrisGan1AdditionalReason'],
    ]);

    // 内面のｶﾞﾝ②のパラメーター項目.
    static PARAM_MAP_INNER_GAN2 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrisGan2ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrisGan2Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrisGan2Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrisGan2Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrisGan2IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrisGan2StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrisGan2IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrisGan2StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrisGan2StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrisGan2IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrisGan2CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrisGan2WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrisGan2AdditionalReason'],
    ]);

    // 内面のﾌﾚｷ①のパラメーター項目.
    static PARAM_MAP_INNER_FLEXI1 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrisFlexi1ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrisFlexi1Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrisFlexi1Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrisFlexi1Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrisFlexi1IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrisFlexi1StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrisFlexi1IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrisFlexi1StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrisFlexi1StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrisFlexi1IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrisFlexi1CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrisFlexi1WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrisFlexi1AdditionalReason'],
    ]);

    // 内面のﾌﾚｷ②のパラメーター項目.
    static PARAM_MAP_INNER_FLEXI2 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrisFlexi2ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrisFlexi2Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrisFlexi2Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrisFlexi2Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrisFlexi2IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrisFlexi2StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrisFlexi2IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrisFlexi2StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrisFlexi2StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrisFlexi2IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrisFlexi2CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrisFlexi2WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrisFlexi2AdditionalReason'],
    ]);

    // 内面の装置①のパラメーター項目.
    static PARAM_MAP_INNER_EQUIPMENT1 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrisEquipment1ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrisEquipment1Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrisEquipment1Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrisEquipment1Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrisEquipment1IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrisEquipment1StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrisEquipment1IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrisEquipment1StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrisEquipment1StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrisEquipment1IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrisEquipment1CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrisEquipment1WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrisEquipment1AdditionalReason'],
    ]);

    // 内面の装置②のパラメーター項目.
    static PARAM_MAP_INNER_EQUIPMENT2 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrisEquipment2ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrisEquipment2Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrisEquipment2Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrisEquipment2Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrisEquipment2IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrisEquipment2StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrisEquipment2IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrisEquipment2StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrisEquipment2StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrisEquipment2IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrisEquipment2CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrisEquipment2WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrisEquipment2AdditionalReason'],
    ]);

    // 内面のﾗﾝｽ①のパラメーター項目.
    static PARAM_MAP_INNER_LANCE1 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrisLance1ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrisLance1Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrisLance1Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrisLance1Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrisLance1IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrisLance1StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrisLance1IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrisLance1StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrisLance1StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrisLance1IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrisLance1CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrisLance1WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrisLance1AdditionalReason'],
    ]);

    // 内面のﾗﾝｽ②のパラメーター項目.
    static PARAM_MAP_INNER_LANCE2 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrisLance2ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrisLance2Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrisLance2Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrisLance2Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrisLance2IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrisLance2StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrisLance2IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrisLance2StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrisLance2StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrisLance2IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrisLance2CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrisLance2WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrisLance2AdditionalReason'],
    ]);

    // 外面のｶﾞﾝ①のパラメーター項目.
    static PARAM_MAP_OUTER_GAN1 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrosGan1ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrosGan1Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrosGan1Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrosGan1Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrosGan1IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrosGan1StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrosGan1IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrosGan1StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrosGan1StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrosGan1IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrosGan1CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrosGan1WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrosGan1AdditionalReason'],
    ]);

    // 外面のｶﾞﾝ②のパラメーター項目.
    static PARAM_MAP_OUTER_GAN2 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrosGan2ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrosGan2Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrosGan2Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrosGan2Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrosGan2IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrosGan2StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrosGan2IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrosGan2StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrosGan2StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrosGan2IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrosGan2CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrosGan2WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrosGan2AdditionalReason'],
    ]);

    // 外面の装置①のパラメーター項目.
    static PARAM_MAP_OUTER_EQUIPMENT1 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrosEquipment1ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrosEquipment1Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrosEquipment1Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrosEquipment1Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrosEquipment1IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrosEquipment1StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrosEquipment1IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrosEquipment1StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrosEquipment1StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrosEquipment1IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrosEquipment1CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrosEquipment1WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrosEquipment1AdditionalReason'],
    ]);

    // 外面の装置②のパラメーター項目.
    static PARAM_MAP_OUTER_EQUIPMENT2 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrosEquipment2ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrosEquipment2Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrosEquipment2Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrosEquipment2Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrosEquipment2IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrosEquipment2StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrosEquipment2IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrosEquipment2StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrosEquipment2StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrosEquipment2IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrosEquipment2CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrosEquipment2WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrosEquipment2AdditionalReason'],
    ]);

    // 超高の本数①のパラメーター項目.
    static PARAM_MAP_SUPER_HIGH_NUM1 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrshNum1ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrshNum1Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrshNum1Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrshNum1Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrshNum1IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrshNum1StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrshNum1IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrshNum1StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrshNum1StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrshNum1IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrshNum1CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrshNum1WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrshNum1AdditionalReason'],
    ]);

    // 超高の本数②のパラメーター項目.
    static PARAM_MAP_SUPER_HIGH_NUM2 = new Map([
        [PlantManagementUtility.CLEANING_RANGE_PARAM.CONSTRUCTION_METHOD, 'resultOfCrshNum2ConstructionMethod'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.SPECIFICATION, 'resultOfCrshNum2Specification'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.NOZZLE, 'resultOfCrshNum2Nozzle'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.PRESSURE, 'resultOfCrshNum2Pressure'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_START, 'resultOfCrshNum2IsStart'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.START_DATETIME, 'resultOfCrshNum2StartDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_STOP, 'resultOfCrshNum2IsStop'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_DATETIME, 'resultOfCrshNum2StopDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.STOP_CUMULATIVE_MINUTE, 'resultOfCrshNum2StopCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.IS_COMPLETE, 'resultOfCrshNum2IsComplete'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.COMPLETE_DATETIME, 'resultOfCrshNum2CompleteDatetime'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.WORK_CUMULATIVE_MINUTE, 'resultOfCrshNum2WorkCumulativeMinute'],
        [PlantManagementUtility.CLEANING_RANGE_PARAM.ADDITIONAL_REASON, 'resultOfCrshNum2AdditionalReason'],
    ]);

    // 洗浄範囲の各パラメーター項目のマップ.
    static CLEANING_RANGE_MAP = new Map([
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_GAN1, PlantManagementUtility.PARAM_MAP_INNER_GAN1],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_GAN2, PlantManagementUtility.PARAM_MAP_INNER_GAN2],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_FLEXI1, PlantManagementUtility.PARAM_MAP_INNER_FLEXI1],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_FLEXI2, PlantManagementUtility.PARAM_MAP_INNER_FLEXI2],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_EQUIPMENT1, PlantManagementUtility.PARAM_MAP_INNER_EQUIPMENT1],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_EQUIPMENT2, PlantManagementUtility.PARAM_MAP_INNER_EQUIPMENT2],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_LANCE1, PlantManagementUtility.PARAM_MAP_INNER_LANCE1],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.INNER_LANCE2, PlantManagementUtility.PARAM_MAP_INNER_LANCE2],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_GAN1, PlantManagementUtility.PARAM_MAP_OUTER_GAN1],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_GAN2, PlantManagementUtility.PARAM_MAP_OUTER_GAN2],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_EQUIPMENT1, PlantManagementUtility.PARAM_MAP_OUTER_EQUIPMENT1],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.OUTER_EQUIPMENT2, PlantManagementUtility.PARAM_MAP_OUTER_EQUIPMENT2],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.SUPER_HIGH_NUM1, PlantManagementUtility.PARAM_MAP_SUPER_HIGH_NUM1],
        [PlantManagementUtility.CONSTRUCTION_METHOD_KEY.SUPER_HIGH_NUM2, PlantManagementUtility.PARAM_MAP_SUPER_HIGH_NUM2],
    ]);

    // ﾉｽﾞﾙの選択項目.
    static OPTION_NOZZLE = ["", "横後", "前開", "ｽﾋﾟﾝ", "-"];

    // 圧力の選択項目.
    static OPTION_PRESSURE = ["", "～30", "31～40", "41～50", "51～70", "71～", "-"];

    // 追加理由の選択項目.
    static OPTION_ADDITIONAL_REASON = ["", "プローブ不入", "硬質スケール付着", "粘性スケール付着", "仕様変更", "自社都合のため", "その他"];

    // 内面のﾌﾚｷの仕様の選択項目.
    static OPTION_SPECIFICATION_INNER_FLEXI = ["", "φ8", "φ10", "φ12", "φ15", "-"];

    // 内面の装置の仕様の選択項目.
    static OPTION_SPECIFICATION_INNER_EQUIPMENT = PlantManagementUtility.OPTION_SPECIFICATION_INNER_FLEXI; // 内面のﾌﾚｷと装置の仕様は同じ選択項目.

    // 内面のﾗﾝｽの仕様の選択項目.
    static OPTION_SPECIFICATION_INNER_LANCE = ["", "φ6", "φ8", "φ10", "φ12", "φ15", "-"];

    // 外面のｶﾞﾝの仕様の選択項目.
    static OPTION_SPECIFICATION_OUTER_GAN = ["", "ｽﾄﾚｰﾄ", "扇形", "-"];

    // 外面の装置の仕様の選択項目.
    static OPTION_SPECIFICATION_OUTER_EQUIPMENT = ["", ".063", ".075", ".082", ".090in", "-"];

    // 指定の熱交の配列からレイアウトの配列を抽出する.
    static extractLayoutArrayOrderByAscFromHeatExchangerArray(heatExchangerArray) {
        // layoutを抽出.
        let layoutArray = _.map(heatExchangerArray, (heatExchanger) => {
            return {
                sceneDetailNumber: heatExchanger.sceneDetailNumber,
                sceneDetailName: heatExchanger.sceneDetailName
            };
        });
        // 未配置を除外.
        let filteredLayoutArray = _.filter(layoutArray, (layout) => {
            return PlantManagementUtility.isDeployed(layout.sceneDetailNumber);
        });
        // ユニークを抽出.
        let uniqArray = _.uniq(filteredLayoutArray, false, (layout) => {
            return layout.sceneDetailNumber;
        });
        // 「現場名(詳細)番号」で昇順ソート.
        return _.sortBy(uniqArray, (layout) => {
            return PlantManagementUtility.parseInt(layout.sceneDetailNumber);
        });
    }

    // 指定の熱交を描画する背景色を取得する.
    static getBackgroundColorByHeatExchanger(heatExchanger) {
        let state = PlantManagementUtility.getHeatExchangerState(heatExchanger);
        return PlantManagementUtility.getBackgroundColorByHeatExchangerState(state);
    }

    // 指定の熱交の状態から描画する背景色を取得する.
    static getBackgroundColorByHeatExchangerState(heatExchangerState) {
        switch (heatExchangerState) {
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.UN_WORKED:
                return 'white';
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.PRETEST_COMPLETE:
                return 'yellow';
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.CLEANING:
                return 'aqua'; // blueだと黒字が見づらい.
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.CLEAN_COMPLETE:
                return 'gray';
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.CARRY_OUT_WAIT:
                return 'gray'; // greenだと黒字が見づらい.
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.CARRY_OUT_COMPLETE:
                return 'silver';
            default:
                throw new Error('予期しない熱交の状態');
        }
    }

    // 指定の日時文字列から現在時刻までの経過の分数を取得する.
    static getDiffMinuteFromNow(targetDatetimeString) {
        let nowDate = new Date();
        let targetDate = new Date(targetDatetimeString);
        let diffAbs = Math.abs(nowDate.getTime() - targetDate.getTime());
        return Math.ceil(diffAbs / (60 * 1000)); // 切り上げ.
    }

    // レイアウト削除時に次に表示するレイアウトのインデックスを取得する.
    static getDisplayTargetLayoutIndexWhenDeleteLayout(layoutArray, deleteTargetSceneDetailNumber) {
        if (layoutArray.length <= 1) {
            throw new Error('レイアウトが1個以下');
        }

        let currentIndex = _.findIndex(layoutArray, (layout) => {
            return layout.sceneDetailNumber === deleteTargetSceneDetailNumber
        });

        // ブラウザのタブと同じ動作(右隣のレイアウトを表示).
        // 終端の場合は左隣のインデックスを返す.
        if (currentIndex === layoutArray.length - 1) {
            return currentIndex - 1;
        }

        return currentIndex;
    }

    // 「装置」ごとにグルーピングしたデータを取得する.
    static getGroupByApparatusArrayOrderByAsc(heatExchangerArray) {
        // 装置機番で昇順ソート.
        let sortedArray = _.sortBy(heatExchangerArray, (heatExchanger) => {
            return heatExchanger.instrumentApparatus + heatExchanger.instrumentMachineNumber;
        });

        // 「装置」でグルーピング.
        return _.groupBy(sortedArray, (heatExchanger) => {
            return heatExchanger.instrumentApparatus;
        });
    }

    // 洗浄予定外の熱交の配列を取得する.
    static getHeatExchangerArrayFilterByNotPlaningOrderByAsc(heatExchangerArray) {
        let filteredArray = _.filter(heatExchangerArray, PlantManagementUtility.isNotPlaningHeatExchanger);

        // 装置機番で昇順ソート.
        return _.sortBy(filteredArray, (heatExchanger) => {
            return heatExchanger.instrumentApparatus + heatExchanger.instrumentMachineNumber;
        });
    }

    // 洗浄予定の熱交の配列を取得する.
    static getHeatExchangerArrayFilterByPlaningOrderByAsc(heatExchangerArray) {
        let filteredArray = _.filter(heatExchangerArray, (heatExchanger) => {
            return !PlantManagementUtility.isNotPlaningHeatExchanger(heatExchanger);
        });

        // 装置機番で昇順ソート.
        return _.sortBy(filteredArray, (heatExchanger) => {
            return heatExchanger.instrumentApparatus + heatExchanger.instrumentMachineNumber;
        });
    }

    // 指定の「現場名(詳細)番号」に配置されている熱交の配列を取得する.
    static getHeatExchangerArrayFilterBySceneDetailNumber(heatExchangerArray, sceneDetailNumber) {
        return _.filter(heatExchangerArray, (heatExchanger) => {
            return heatExchanger.sceneDetailNumber === sceneDetailNumber;
        });
    }

    // 指定のIDの熱交のデータを取得する.
    static getHeatExchangerByHeatExchangerId(heatExchangerArray, heatExchangerId) {
        return _.find(heatExchangerArray, (heatExchanger) => {
            return heatExchanger.heatExchangerId === heatExchangerId;
        });
    }

    // 指定の熱交の配列から熱交IDの配列を取得する.
    static getHeatExchangerIdArrayByHeatExchangerArray(heatExchangerArray) {
        return _.map(heatExchangerArray, (heatExchanger) => {
            return heatExchanger.heatExchangerId;
        });
    }

    // 指定の「現場名(詳細)番号」に配置されている熱交IDの配列を取得する.
    static getHeatExchangerIdArrayFilterBySceneDetailNumber(heatExchangerArray, sceneDetailNumber) {
        let array = PlantManagementUtility.getHeatExchangerArrayFilterBySceneDetailNumber(heatExchangerArray, sceneDetailNumber);
        return PlantManagementUtility.getHeatExchangerIdArrayByHeatExchangerArray(array);
    }

    // レイアウト内熱交の配列から指定の熱交IDに一致するレイアウト内熱交を取得する.
    static getHeatExchangerInLayoutRefByHeatExchangerId(heatExchangerInLayoutRefs, heatExchangerId) {
        let filteredArray = _.filter(heatExchangerInLayoutRefs, (heatExchangerInLayoutRef) => {
            return heatExchangerInLayoutRef.current.props.heatExchanger.heatExchangerId === heatExchangerId;
        });
        return filteredArray[0];
    }

    // 指定の「本数」から描画する熱交の縦幅を取得する.
    static getHeatExchangerRectHeight(instrumentNumberOfLinesString) {
        // 各値はAndroidアプリから引用.
        const BASE = 69 * 0.7;
        const BIG = BASE + BASE / 3;
        const SMALL = BASE - BASE / 3;
        const BORDER_BIG = 800;
        const BORDER_SMALL = 400;

        let intValue = PlantManagementUtility.parseInt(instrumentNumberOfLinesString);
        if (intValue > BORDER_BIG) {
            return BIG;
        } else if (intValue < BORDER_SMALL) {
            return SMALL;
        } else {
            return BASE;
        }
    }

    // 指定の「長さ」から描画する熱交の横幅を取得する.
    static getHeatExchangerRectWidth(instrumentLengthString) {
        // 各値はAndroidアプリから引用.
        const BASE = 168 * 0.7;
        const BIG = BASE + BASE / 3;
        const SMALL = BASE - BASE / 3;
        const BORDER_BIG = 8000;
        const BORDER_SMALL = 4000;

        let intValue = PlantManagementUtility.parseInt(instrumentLengthString);
        if (intValue > BORDER_BIG) {
            return BIG;
        } else if (intValue < BORDER_SMALL) {
            return SMALL;
        } else {
            return BASE;
        }
    }

    // 指定の熱交の状態を取得する.
    static getHeatExchangerState(heatExchanger) {
        // 搬出済み.
        if (PlantManagementUtility.isParamTrue(heatExchanger.resultOfProcessIsCompleteCarryOut)) {
            return PlantManagementUtility.HEAT_EXCHANGER_STATE.CARRY_OUT_COMPLETE;
        }

        // 前検が完了していなければ未洗浄.
        if (!PlantManagementUtility.isParamTrue(heatExchanger.resultOfProcessIsCompletePretest)) {
            return PlantManagementUtility.HEAT_EXCHANGER_STATE.UN_WORKED;
        }

        // 洗浄完了 or 搬出待ち.
        if (PlantManagementUtility.isCompleteAllCleaning(heatExchanger)) {
            // 搬出待ち.
            if (PlantManagementUtility.isCompleteAllProcess(heatExchanger)) {
                return PlantManagementUtility.HEAT_EXCHANGER_STATE.CARRY_OUT_WAIT;
            }

            // 洗浄完了.
            return PlantManagementUtility.HEAT_EXCHANGER_STATE.CLEAN_COMPLETE;
        }

        // 洗浄中.
        if (PlantManagementUtility.isCleaning(heatExchanger)) {
            return PlantManagementUtility.HEAT_EXCHANGER_STATE.CLEANING;
        }

        // 前検完了.
        return PlantManagementUtility.HEAT_EXCHANGER_STATE.PRETEST_COMPLETE;
    }

    // 指定の熱交の配列における指定の熱交IDのインデックス番号を取得する.
    static getIndexOfHeatExchangerByHeatExchangerId(heatExchangerArray, heatExchangerId) {
        let idArray = PlantManagementUtility.getHeatExchangerIdArrayByHeatExchangerArray(heatExchangerArray);
        return _.indexOf(idArray, heatExchangerId);
    }

    // 指定のレイアウトの配列から指定の「現場名(詳細)番号」を除いたレイアウトの配列を取得する.
    static getLayoutArrayRejectBySceneDetailNumber(layoutArray, rejectTargetSceneDetailNumber) {
        return _.reject(layoutArray, (layout) => {
            return layout.sceneDetailNumber === rejectTargetSceneDetailNumber;
        });
    }

    // 指定のレイアウトの配列から指定の「現場名(詳細)番号」に一致するレイアウトのインデックスを取得する.
    static getLayoutIndexBySceneDetailNumber(layoutArray, sceneDetailNumber) {
        return _.findIndex(layoutArray, (layout) => {
            return layout.sceneDetailNumber === sceneDetailNumber;
        });
    }

    // 指定の熱交の描画するテキストの色を取得する.
    static getTextColorByHeatExchanger(heatExchanger) {
        let state = PlantManagementUtility.getHeatExchangerState(heatExchanger);
        return PlantManagementUtility.getTextColorByHeatExchangerState(state);
    }

    // 指定の熱交の状態から描画するテキストの色を取得する.
    static getTextColorByHeatExchangerState(heatExchangerState) {
        switch (heatExchangerState) {
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.UN_WORKED:
                return 'black';
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.PRETEST_COMPLETE:
                return 'black';
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.CLEANING:
                return 'black';
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.CLEAN_COMPLETE:
                return 'white';
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.CARRY_OUT_WAIT:
                return 'white';
            case PlantManagementUtility.HEAT_EXCHANGER_STATE.CARRY_OUT_COMPLETE:
                return 'rgba(0,0,0,0.26)'; // disabledと同じRGBA.
            default:
                throw new Error('予期しない熱交換器の状態が指定されました。');
        }
    }

    // 指定の熱交の洗浄中であるかを判定する.
    static isCleaning(heatExchanger) {
        return PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrisGan1IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrisGan2IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrisFlexi1IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrisFlexi2IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrisEquipment1IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrisEquipment2IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrisLance1IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrisLance2IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrosGan1IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrosGan2IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrosEquipment1IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrosEquipment2IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrshNum1IsStart)
            || PlantManagementUtility.isParamTrue(heatExchanger.resultOfCrshNum2IsStart);
    }

    // すべての洗浄範囲が作業完了しているかを判定する.
    static isCompleteAllCleaning(heatExchanger) {
        return PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrisGan1ConstructionMethod, heatExchanger.resultOfCrisGan1IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrisGan2ConstructionMethod, heatExchanger.resultOfCrisGan2IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrisFlexi1ConstructionMethod, heatExchanger.resultOfCrisFlexi1IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrisFlexi2ConstructionMethod, heatExchanger.resultOfCrisFlexi2IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrisEquipment1ConstructionMethod, heatExchanger.resultOfCrisEquipment1IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrisEquipment2ConstructionMethod, heatExchanger.resultOfCrisEquipment2IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrisLance1ConstructionMethod, heatExchanger.resultOfCrisLance1IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrisLance2ConstructionMethod, heatExchanger.resultOfCrisLance2IsComplete)
            && PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrosGan1ConstructionMethod, heatExchanger.resultOfCrosGan1IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrosGan2ConstructionMethod, heatExchanger.resultOfCrosGan2IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrosEquipment1ConstructionMethod, heatExchanger.resultOfCrosEquipment1IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrosEquipment2ConstructionMethod, heatExchanger.resultOfCrosEquipment2IsComplete)
            && PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrshNum1ConstructionMethod, heatExchanger.resultOfCrshNum1IsComplete)
            //&& PlantManagementUtility.isCompleteConstructionMethod(heatExchanger.resultOfCrshNum2ConstructionMethod, heatExchanger.resultOfCrshNum2IsComplete);
            && PlantManagementUtility.isCompleteProcess(heatExchanger.systemInfoAdditionalFlag, heatExchanger.planOfProcessAirBlow, heatExchanger.resultOfProcessIsCompleteAirBlow)
    }

    // すべての工程作業が完了しているかを判定する.
    static isCompleteAllProcess(heatExchanger) {
        return PlantManagementUtility.isParamTrue(heatExchanger.resultOfProcessIsCompletePretest)
            && PlantManagementUtility.isCompleteProcess(heatExchanger.systemInfoAdditionalFlag, heatExchanger.planOfProcessAirBlow, heatExchanger.resultOfProcessIsCompleteAirBlow)
            && PlantManagementUtility.isCompleteProcess(heatExchanger.systemInfoAdditionalFlag, heatExchanger.planOfProcessEt, heatExchanger.resultOfProcessIsCompleteEt)
            && PlantManagementUtility.isCompleteProcess(heatExchanger.systemInfoAdditionalFlag, heatExchanger.planOfProcessFtect, heatExchanger.resultOfProcessIsCompleteFtect)
            && PlantManagementUtility.isCompleteProcess(heatExchanger.systemInfoAdditionalFlag, heatExchanger.planOfProcessIris, heatExchanger.resultOfProcessIsCompleteIris);
    }

    // 洗浄範囲の工法の作業が完了しているかを判定する.
    static isCompleteConstructionMethod(constructionMethod, isComplete) {
        // 予定されていなければ完了とする.
        if (constructionMethod === "") {
            return true;
        }

        return PlantManagementUtility.isParamTrue(isComplete);
    }

    // 工程作業が完了しているかを判定する.
    static isCompleteProcess(systemInfoAdditionalFlag, plan, resultComplete) {
        // 予定されていなければ完了とする.
        if (!PlantManagementUtility.isPlanedProcess(systemInfoAdditionalFlag, plan)) {
            return true;
        }

        // 予定されている && 実績が完了であれば完了.
        // noinspection RedundantIfStatementJS
        if (PlantManagementUtility.isParamTrue(resultComplete)) {
            return true;
        }

        return false;
    }

    // 配置済みかを判定する.
    static isDeployed(sceneDetailNumber) {
        return sceneDetailNumber !== PlantManagementUtility.NOT_DEPLOY_LAYOUT;
    }

    // 洗浄予定外の熱交であるかを判定する.
    static isNotPlaningHeatExchanger(heatExchanger) {
        return heatExchanger.planOfCrInternalMpa === ''
            && heatExchanger.planOfCrExternalMpa === ''
            && heatExchanger.planOfCrSuperHigh === ''
            && heatExchanger.planOfProcessAirBlow === ''
            && heatExchanger.planOfProcessEt === ''
            && heatExchanger.planOfProcessFtect === ''
            && heatExchanger.planOfProcessIris === ''
            && heatExchanger.systemInfoAdditionalFlag === '';
    }

    // ブランクor"○"の項目が"○"であるかを判定する.
    static isParamTrue(value) {
        return value === PlantManagementUtility.PARAM_BOOL.TRUE;
    }

    // 工程作業が予定ありかを判定する.
    static isPlanedProcess(systemInfoAdditionalFlag, plan) {
        // 「追加熱交フラグ」がONの場合は予定あり.
        if (PlantManagementUtility.isParamTrue(systemInfoAdditionalFlag)) {
            return true;
        } else {
            return PlantManagementUtility.isParamTrue(plan);
        }
    }

    // 数字の文字列であればその数値を返し,数字の文字列でなければ0を返す.
    static parseInt(valueString) {
        let valueInt = parseInt(valueString);
        if (_.isNaN(valueInt)) {
            return 0;
        }
        return valueInt;
    }

    // ソートした現場名一覧を返す.
    static sortSceneList(sceneList) {
        let sortSceneList = Utility.getDeepCopy(sceneList);
        sortSceneList.sort((a, b) => {
            // 第1ソート：「現場名(sceneName)」で昇順ソート.
            // 第2ソート：「アップロード日時(uploadDatetime)」で降順ソート.
            // Blank.
            if(a.sceneName === '' && b.sceneName === '' && a.uploadDatetime < b.uploadDatetime) return 1;
            if(a.sceneName === '' && b.sceneName === '' && a.uploadDatetime > b.uploadDatetime) return -1;
            if(a.sceneName === '') return -1;
            if(b.sceneName === '') return 1;
            // null.
            if(a.sceneName == null && b.sceneName == null && a.uploadDatetime < b.uploadDatetime) return 1;
            if(a.sceneName == null && b.sceneName == null && a.uploadDatetime > b.uploadDatetime) return -1;
            if(a.sceneName == null) return -1;
            if(b.sceneName == null) return 1;
            // Blankまたはnull以外.
            if(a.sceneName.toString().toLowerCase() < b.sceneName.toString().toLowerCase()) return -1;
            if(a.sceneName.toString().toLowerCase() > b.sceneName.toString().toLowerCase()) return  1;
            if(a.uploadDatetime < b.uploadDatetime) return  1;
            if(a.uploadDatetime > b.uploadDatetime) return -1;
            // 同一値.
            return 0;
        });
        return sortSceneList;
    }
}

export default PlantManagementUtility;
